import { render, staticRenderFns } from "./ResizableWidth.vue?vue&type=template&id=1b172b94&scoped=true&"
import script from "./ResizableWidth.vue?vue&type=script&lang=js&"
export * from "./ResizableWidth.vue?vue&type=script&lang=js&"
import style0 from "./ResizableWidth.vue?vue&type=style&index=0&id=1b172b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b172b94",
  null
  
)

export default component.exports